import { FC } from "react";

import { useMultiStyleConfig } from "@chakra-ui/react";

import { Button } from "@components/buttons";

import type { TTimeOptionProps } from "./types";

const TimeOption: FC<TTimeOptionProps> = ({ option, isSelected, onSelect }) => {
  const styles = useMultiStyleConfig("TimePicker", {});
  return (
    <Button
      variant={isSelected ? "main" : "transparent"}
      size="sm"
      sx={styles.option}
      label={option.time}
      isDisabled={option.isDisabled}
      onClick={() => onSelect(option)}
    />
  );
};
export default TimeOption;
